import { render } from "./ChangePassword.vue?vue&type=template&id=4894df62&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=4894df62&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4894df62"]])

export default __exports__